import React, { Suspense, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import bem from 'utils/bem';
import Text from 'components/Text';
import Model from '../../../model';
import PurchaseTeaser, { PurchaseTeaserSkeleton } from 'components/PurchaseTeaser';
import './index.sass';
import { times } from 'utils/render';
import { Skeleton } from '@mui/material';
import Loader from 'components/Loader';
import OfficeEmptyBlock from 'components/OfficeEmptyBlock';
import { useNavigate } from 'react-router';

const { block, el } = bem('purchases');
const Purchases = () => {

    const { getUserPurchases, userPurchaseData } = Model.user;

    useEffect(() => {
        getUserPurchases();
    }, []);

    return (
        <Suspense fallback={ <Loader /> }>
            <div className={ block() }>
                <PurchasesBlock resource={ userPurchaseData }/>
            </div>
        </Suspense>
    )
}

const PurchasesBlock = ({ resource }) => {
    resource.read();
    const { groupedPurchases } = Model.user;
    const navigate = useNavigate();

    const goToShop = useCallback(() => {
        navigate('/goods');
    }, [])

    if (groupedPurchases.size === 0) {
        return (
            <OfficeEmptyBlock
                primaryText={ 'Покупки отсутствуют' }
                secondaryText={ 'Вы еще не совершали покупки' }
                buttonText={ 'В магазин' }
                onClick={ goToShop }
                icon={ 'shopping-cart' }
            />
        )
    }

    return [ ...groupedPurchases.entries() ].map(([ date, purchases ]) => {
        return <Group key={ date } date={ date } purchases={ purchases }/>
    })
}

const Group = ({ date, purchases }) => {
    return (
        <div className={ el('group-block') }>
            <div className={ el('group-block-header') }>
                <Text>{ date }</Text>
            </div>
            <div className={ el('group-block-list') }>
                { purchases.map(purchase => <PurchaseTeaser key={ purchase.id } item={ purchase }/>) }
            </div>
        </div>
    )
}

const GroupSkeleton = () => {
    return (
        <div className={ el('group-block') }>
            <div className={ el('group-block-header') }>
                <Text><Skeleton width={ 90 }/></Text>
            </div>
            <div className={ el('group-block-list') }>
                { times((key) => <PurchaseTeaserSkeleton key={ key }/>, 1) }
            </div>
        </div>
    )
}

const PurchasesBlockSkeleton = () => {
    return (
        times((key) => <GroupSkeleton key={ key }/>, 2)
    )
}

export default observer(Purchases);
